import { createContext } from 'react';

interface ModalContextValues 
{
    close(): void;
}

export const ModalContext = createContext<ModalContextValues>({
    close: () => {}
});